import Model, { attr } from '@ember-data/model';
import type { CustomSubdomainOptions } from 'uplisting-frontend/models/direct-booking-configuration';

export enum DbePlan {
  basic = 'basic',
  plus = 'plus',
}

export default class DudaConfigurationModel extends Model {
  @attr('string') subdomain!: string;
  @attr('string') customDomain!: string;
  @attr('string') customSubdomainOption!: CustomSubdomainOptions;
  @attr('string') dbePlan!: DbePlan;
  @attr('string') templateAlias?: string;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'duda-configuration': DudaConfigurationModel;
  }
}
